import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/common.css';
import '../assets/css/member-list.css';
import CustomButtons from '../components/CustomButtons';
import { adminService } from '../services/adminService';

function BranchList() {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [newName, setNewName] = useState('');
  const [newAddress, setNewAddress] = useState('');
  const [newPhone, setNewPhone] = useState('');
  const [error, setError] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editAddress, setEditAddress] = useState('');
  const [editPhone, setEditPhone] = useState('');
  const [editError, setEditError] = useState('');
  const [editManagerId, setEditManagerId] = useState('');
  const navigate = useNavigate();

  const userRole = parseInt(localStorage.getItem('userRole'), 10);
  const isAdmin = [1,2,3].includes(userRole);
  const canEdit = isAdmin || userRole === 4;

  const fetchBranches = async () => {
    setLoading(true);
    try {
      const data = await adminService.getBranches();
      setBranches(data.branches || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const handleAdd = async () => {
    setError('');
    if (!newName.trim()) {
      setError('拠点名を入力してください。');
      return;
    }
    try {
      await adminService.addBranch({ name: newName, address: newAddress, phoneNumber: newPhone });
      setNewName('');
      setNewAddress('');
      setNewPhone('');
      setShowForm(false);
      fetchBranches();
    } catch (err) {
      setError(err.message || '拠点追加に失敗しました。');
    }
  };

  const startEdit = (b) => {
    setEditingId(b.id);
    setEditName(b.name);
    setEditAddress(b.address || '');
    setEditPhone(b.phoneNumber || '');
    setEditManagerId(b.managerId || '');
    setEditError('');
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditError('');
  };

  const handleUpdate = async () => {
    setEditError('');
    if (!editName.trim()) {
      setEditError('拠点名を入力してください。');
      return;
    }
    try {
      await adminService.updateBranch(editingId, { name: editName, address: editAddress, phoneNumber: editPhone, managerId: editManagerId || null });
      setEditingId(null);
      fetchBranches();
    } catch (err) {
      setEditError(err.message || '拠点編集に失敗しました。');
    }
  };

  return (
    <div className="container">
      <h1 className="text-primary text-center mb-4">支社一覧</h1>

      {loading ? (
        <p className="text-center">読み込み中...</p>
      ) : (
        <table className="details-table">
          <thead>
            <tr>
              <th>拠点名</th>
              <th>住所</th>
              <th>電話番号</th>
              <th>支社長</th>
              <th>メンバー数</th>
              {canEdit && <th>操作</th>}
            </tr>
          </thead>
          <tbody>
            {branches.length === 0 ? (
              <tr><td colSpan={canEdit ? 6 : 5} className="text-muted">拠点が登録されていません</td></tr>
            ) : (
              branches.map(b => (
                editingId === b.id ? (
                  <tr key={b.id}>
                    <td>
                      <input type="text" className="form-control form-control-sm" value={editName} onChange={e => setEditName(e.target.value)} maxLength={255} />
                    </td>
                    <td>
                      <input type="text" className="form-control form-control-sm" value={editAddress} onChange={e => setEditAddress(e.target.value)} maxLength={500} />
                    </td>
                    <td>
                      <input type="text" className="form-control form-control-sm" value={editPhone} onChange={e => setEditPhone(e.target.value)} maxLength={20} />
                    </td>
                    <td>
                      {isAdmin ? (
                        <select className="form-control form-control-sm" value={editManagerId} onChange={e => setEditManagerId(e.target.value)}>
                          <option value="">未設定</option>
                          {(b.members || []).map(m => (
                            <option key={m.id} value={m.id}>{m.name}</option>
                          ))}
                        </select>
                      ) : (b.managerName || '未設定')}
                    </td>
                    <td>{b.memberCount ?? 0}名</td>
                    <td>
                      {editError && <div style={{color:'#d32f2f',fontSize:'0.8rem',marginBottom:4}}>{editError}</div>}
                      <button className="btn btn-primary btn-sm" onClick={handleUpdate} style={{marginRight:4}}>保存</button>
                      <button className="btn btn-secondary btn-sm" onClick={cancelEdit}>取消</button>
                    </td>
                  </tr>
                ) : (
                  <tr key={b.id}>
                    <td>{b.name}</td>
                    <td>{b.address || '-'}</td>
                    <td>{b.phoneNumber || '-'}</td>
                    <td>{b.managerName || '未設定'}</td>
                    <td>
                      <button className="btn btn-link btn-sm p-0" onClick={() => navigate(`/member-list?branchId=${b.id}`)}>
                        {b.memberCount ?? 0}名
                      </button>
                    </td>
                    {canEdit && (
                      <td>
                        <button className="btn btn-outline-primary btn-sm" onClick={() => startEdit(b)}>編集</button>
                      </td>
                    )}
                  </tr>
                )
              ))
            )}
          </tbody>
        </table>
      )}

      {/* 拠点追加フォーム（管理者/人事のみ） */}
      {!showForm ? (
        isAdmin && (
          <div style={{ marginTop: 16 }}>
            <button className="btn btn-primary btn-sm" onClick={() => setShowForm(true)}>
              拠点を追加
            </button>
          </div>
        )
      ) : (
        <div className="search-controls" style={{ marginTop: 16 }}>
          <h3 style={{ marginBottom: 12 }}>新しい拠点を追加</h3>
          {error && <div className="error-message" style={{ color: '#d32f2f', background: '#ffeaea', padding: '8px 12px', borderRadius: 4, marginBottom: 8 }}>{error}</div>}
          <div className="search-row">
            <label style={{ fontWeight: 'bold', minWidth: 80 }}>
              拠点名 <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="text"
              className="search-input"
              placeholder="例: 福岡開発ルーム"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              maxLength={255}
            />
          </div>
          <div className="search-row">
            <label style={{ fontWeight: 'bold', minWidth: 80 }}>住所</label>
            <input
              type="text"
              className="search-input"
              placeholder="例: 〒810-0001 福岡市中央区天神1-1-1"
              value={newAddress}
              onChange={(e) => setNewAddress(e.target.value)}
              maxLength={500}
            />
          </div>
          <div className="search-row">
            <label style={{ fontWeight: 'bold', minWidth: 80 }}>電話番号</label>
            <input
              type="text"
              className="search-input"
              placeholder="例: 092-123-4567"
              value={newPhone}
              onChange={(e) => setNewPhone(e.target.value)}
              maxLength={20}
            />
          </div>
          <div className="search-row">
            <button className="btn btn-primary btn-sm" onClick={handleAdd}>追加</button>
            <button className="btn btn-secondary btn-sm" onClick={() => { setShowForm(false); setError(''); }}>キャンセル</button>
          </div>
        </div>
      )}

      <CustomButtons
        rightLabel="マイページへ戻る"
        onRightClick={() => navigate('/')}
        leftLabel=""
        leftClassName="d-none"
      />
    </div>
  );
}

export default BranchList;
